import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { effect, inject } from '@angular/core';
import { BaseState, withCrudOperations } from '../crud.state';
import { Access, mergeAccessList, Role } from '../../models/rbac';
import { RoleService } from '../../services/role/role.service';
import { withRoleSelectors } from './role.selectors';
import { withLogging } from '../features/logger.feature';
import { ActiveUserStore } from '../user/active-user.state';

export type RoleState = BaseState<Role>;

export const initialState: RoleState = {
  items: {},
  loading: false,
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  selectedId: '',
  selection: [],
  entityType: 'Role',
  entityLabel: 'Rollen',
  events: {
    add: ['linkRoleToWsControl'],
  },
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const RoleStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Role>(RoleService),
  withLogging(initialState.entityType),
  withMethods(store => ({
    actionsByRoleIds(ids: string[]): Access {
      const roles = store.getByIds(ids);
      return mergeAccessList(
        roles.map((role: Role) => {
          return role.accessList;
        })
      );
    },
  })),
  withRoleSelectors(),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // See category.state.ts for why this watches commune reactively
      // instead of firing once at construction time.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
